"use client";
import r from "styled-components";
import e from "react";
const o = r.div``, s = r.div``, b = ({
  linkExternal: l,
  subject: t,
  linkTitle: n
}) => /* @__PURE__ */ e.createElement(e.Fragment, null, !!t && /* @__PURE__ */ e.createElement("li", null, " ", /* @__PURE__ */ e.createElement(
  "a",
  {
    href: `/${process.env.NEXT_PUBLIC_STATS_BASE_URL}/${t.slug}`
  },
  n || t.name
)), !t && !!l && !!n && /* @__PURE__ */ e.createElement("li", null, /* @__PURE__ */ e.createElement("a", { className: "bl-link", href: l }, n))), u = ({ description: l, subjects: t, title: n }) => /* @__PURE__ */ e.createElement(s, null, /* @__PURE__ */ e.createElement("h2", { className: "bl-size-2 bl-m-b-3" }, n), /* @__PURE__ */ e.createElement("p", { className: "bl-size-4 bl-m-b-3" }, l), /* @__PURE__ */ e.createElement("ul", { className: "bl-link-list bl-link-list--pointer bl-link-list--full-width" }, t.filter((a) => a.subject || a.linkExternal && a.linkTitle).map(({ linkExternal: a, linkTitle: m, subject: c }, i) => /* @__PURE__ */ e.createElement(
  b,
  {
    key: `${l}-${n}-${i}`,
    subject: c || void 0,
    linkTitle: m || void 0,
    linkExternal: a || void 0
  }
)))), p = ({ subjectGroups: l }) => l && l.length > 0 && /* @__PURE__ */ e.createElement(o, { className: "bl-container bl-container--medium bl-grid bl-grid--two-columns bl-grid--big-row-gap bl-m-t-7" }, l.map(({ ...t }) => /* @__PURE__ */ e.createElement(
  u,
  {
    ...t,
    key: `subject-group-${t.title}`
  }
))) || /* @__PURE__ */ e.createElement(e.Fragment, null);
export {
  p as default
};
//# sourceMappingURL=index.es61.js.map
